"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UIControlledPopover = _interopRequireDefault(require("./UIControlledPopover"));

var _default = (0, _Controllable.default)(_UIControlledPopover.default, ['open']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/tooltip/UIPopover.js
// module id = 787
// module chunks = 209 210 211 212